import { toastMessage } from "@/utils/appInstance";

function limpa_formulario_cnpj(form) {
  form.razao_social = "";
  form.fantasia = "";
  form.cep = "";
  form.numero = "";
  form.complemento = "";
}

export async function buscarCnpj(cnpj, form) {
  cnpj = cnpj.replace(/\D/g, "");

  if (form.personalidade === "PJ" && cnpj !== "") {
    const validar_cnpj = /^[0-9]{14}$/;

    if (!validar_cnpj.test(cnpj)) {
      limpa_formulario_cnpj(form);
      toastMessage("warn", "Formato de CNPJ inválido.", "Informe um formato válido.");
      return;
    }

    form.razao_social = "...";
    form.fantasia = "...";
    form.cep = "...";
    form.numero = "...";
    form.complemento = "...";

    try {
      const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`);

      if (response.ok) {
        const dados = await response.json();
        form.razao_social = dados.razao_social?.toUpperCase() || "";
        form.fantasia = dados.nome_fantasia?.toUpperCase() || "";
        form.cep = dados.cep;
        form.numero = dados.numero;
        form.complemento = dados.complemento;
      } else if (response.status === 404) {
        // CNPJ não encontrado
        limpa_formulario_cnpj(form);
        toastMessage("warn", "CNPJ não encontrado.", "Tente novamente.");
      } else {
        // Outros erros
        limpa_formulario_cnpj(form);
        toastMessage("warn", "Erro na consulta.", "Tente novamente mais tarde.");
      }
    } catch (error) {
      console.error("Erro ao buscar o CNPJ:", error);
      limpa_formulario_cnpj(form);
      toastMessage("warn", "Erro na consulta.", "Tente novamente mais tarde.");
    }
  }
}
